import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import Restricted from "src/app/Restricted";
import { getSearchPath } from "src/consts/urlPaths";

type PeopleLinkProps = {
  children?: ReactNode;
  item: { name?: string };
  className?: string;
};

const PeopleLink = ({ children, item, className }: PeopleLinkProps) => (
  <Restricted>
    <Link
      id="people-nav-link"
      to={getSearchPath("people", null, false)}
      aria-label={item.name}
      className={className}
    >
      {children}
    </Link>
  </Restricted>
);

export default PeopleLink;
